import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { authToken, ImagesDomain, StoryDay, StoryItem, StoryType } from "../../models/commonModels";
import { AppDispatch } from "..";
import runningHttpClient from "../../axios";       
import { fetchError } from "../app-slice/AppSlice";
import { AxiosError } from "axios";

interface InitSt{
    storys:StoryDay[],
    page:number,
    hasMore:boolean,
    dateArr:string[],
    isLoad:boolean,
    commentStory:StoryItem|null
}

const initSt:InitSt={
    storys:[],
    page:0,
    hasMore:true,
    dateArr:[],
    isLoad:false,
    commentStory:null
}
const LentaSlice = createSlice({
    name:"LentaClice",
    initialState:initSt,
    reducers:{
        fetchStory(state, action:PayloadAction<StoryDay[]>){
            if(action.payload.length==0){
                state.hasMore=false;
                return;
            }
            action.payload.forEach((item)=>{
                const itemDate:StoryDay = state.storys.find((c)=> c.activity_date===item.activity_date) as StoryDay;
                if(itemDate){
                    itemDate.activity_date_list = [...itemDate.activity_date_list, ...item.activity_date_list]
                }else{
                    state.storys.push(item)
                }
            })
            //state.storys=[...state.storys, ...action.payload]
        },
        remooveStorys(state){
            state.storys=[];
            state.dateArr=[];
            state.page=0;
            state.hasMore=true;
        },
        setPageUp(state){
            state.page=state.page+1;
        },
        setHasMore(state,action:PayloadAction<boolean>){
            state.hasMore=action.payload
        },
        setLoad(state, actions:PayloadAction<boolean>){
            state.isLoad=actions.payload
        },
        setCommentStory(state, action:PayloadAction<StoryItem|null>){
            if(action==null){
                state.commentStory=null;
                return
            }
            state.commentStory=action.payload
        },
        updateStoryItem(state, action:PayloadAction<StoryItem>){
            var SD:StoryDay[]=[];
            state.storys.forEach((day)=>{
                const SI:StoryItem[] = [];
                day.activity_date_list.forEach((item)=>{if(item.story_id===action.payload.story_id){
                    SI.push(action.payload)
                }else{
                    SI.push(item)
                }})
                SD.push({...day,activity_date_list:SI})
            })
            state.storys=SD;
        }
    }
})

export const{
    fetchStory,
    remooveStorys,
    setPageUp,
    setHasMore,
    setLoad,
    setCommentStory,
    updateStoryItem
}=LentaSlice.actions;

export default LentaSlice.reducer;

export const getStoryPage=(page:number, token:string, search?:string|null) => async(dispatch:AppDispatch)=>{
    dispatch(setLoad(true))
    try{
        const result = await runningHttpClient.get<StoryDay[]>('api/v2/story', {params:{
            page:page,
            search:search
            
        }, headers:{'Authorization':token}})
        if(result.status===200){
            if(result.data.length==0){
                dispatch(setHasMore(false))
            }else{
                dispatch(fetchStory(result.data))
            }
        }

    }catch(e){
        dispatch(fetchError((e as AxiosError).message))
       
    }finally{
        dispatch(setLoad(false))
    }
}

export const sendReaction = (storyId:number, reaction:string) =>async (dispatch:AppDispatch)=>{
    try{
        const res = await runningHttpClient.post('api/v1/story/like', {story_id:storyId,emoji:reaction})
        if(res.status===200){
            dispatch(UpdateStoryItem(storyId))
        }
    }catch(e){
        dispatch(fetchError((e as AxiosError).message))
    }finally{
        //UpdateStoryItem(storyId)
    }
}

export const UpdateStoryItem=(storyId:number)=>async (dispatch:AppDispatch)=>{
    const res = await runningHttpClient.get<StoryItem>('api/v1/story', {params:{story_id:storyId}})
    if(res.status===200){
        dispatch(updateStoryItem(res.data))
    }
}

// api/v1/story?story_id= - получить стори по id